import { CardsTutorial, TutorialItem } from "./cards-tutorial";

type TutorialSidebarProps = {
  selectedKey?: string;
  onSelect: (tutorial: TutorialItem) => void;
};

export function TutorialSidebar({
  selectedKey,
  onSelect,
}: TutorialSidebarProps) {
  return (
    <div className="space-y-3 xl:sticky xl:top-4 xl:self-start">
      <div className="rounded-2xl border border-gray/15 bg-white px-4 py-3 shadow-sm">
        <h2 className="text-base font-semibold text-gray3">
          Trilhas disponiveis
        </h2>
        <p className="mt-1 text-sm text-gray2">
          Selecione um tema para atualizar o painel.
        </p>
      </div>

      <div className="overflow-hidden rounded-2xl border border-gray/15 bg-white shadow-sm">
        <div className="max-h-[calc(100vh-210px)] overflow-y-auto p-3">
          <CardsTutorial selectedKey={selectedKey} onSelect={onSelect} />
        </div>
      </div>
    </div>
  );
}
